<div class="px-3 py-4" data-automation="upload-progress-modal">
  <h4 data-automation="upload-progress-modal-message">{{ modalProperties.message | translate }}</h4>
  <ngb-progressbar
    striped="true"
    type="primary"
    animated="true"
    [value]="modalProperties?.fileUploadProgress | async"
    data-automation="upload-progress-modal-progressbar"
  ></ngb-progressbar>
</div>
